class RegisterEndorsementRequest {

    getRegisterEndorsement = (datosRegistroEndoso) => {
        return {
            "datos": {
                "tipoEndoso"                : datosRegistroEndoso.tipoEndoso,
                "codigoBanco"               : datosRegistroEndoso.codigoBanco,
                "tipoCuentaBanco"           : datosRegistroEndoso.tipoCuentaBanco,
                "numeroCuenta"              : datosRegistroEndoso.numeroCuenta,
                "codigoCuentaInterbancario" : datosRegistroEndoso.codigoCuentaInterbancario,
                "montoSolicitud"            : datosRegistroEndoso.montoSolicitud,
                "codigoMonedaSolicitud"     : datosRegistroEndoso.codigoMonedaSolicitud,
                "archivos"                  : datosRegistroEndoso.archivos,
                "contacto"  : {
                    "nombre"            : datosRegistroEndoso.nombre,
                    "apellidoPaterno"   : datosRegistroEndoso.apellidoPaterno,
                    "apellidoMaterno"   : datosRegistroEndoso.apellidoMaterno,
                    "tipoDocumento"     : datosRegistroEndoso.tipoDocumento,
                    "numeroDocumento"   : datosRegistroEndoso.numeroDocumento,
                    "celular"           : datosRegistroEndoso.celular,
                    "correo"            : datosRegistroEndoso.correo,
                }
            }
        };
    }
}

export default RegisterEndorsementRequest;